// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AppSwitcherController from "./app_switcher_controller"
application.register("app-switcher", AppSwitcherController)

import BildinhalteController from "./bildinhalte_controller"
application.register("bildinhalte", BildinhalteController)

import CollectionSelectController from "./collection_select_controller"
application.register("collection-select", CollectionSelectController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import InhaltFormController from "./inhalt_form_controller"
application.register("inhalt-form", InhaltFormController)

import MerkmalController from "./merkmal_controller"
application.register("merkmal", MerkmalController)

import TagMultimarkerController from "./tag_multimarker_controller"
application.register("tag-multimarker", TagMultimarkerController)
